export { AuthorArticle } from './author-article.component'
